<template>
    <div> 
        <sim-radio-buttons
            :mobile_form="mobile_form"  
            :id="identifier"
            :labels="labels"  
        ></sim-radio-buttons>
    </div>
</template>

<script setup>
import SimRadioButtons from "./SimRadioButtons.vue";
import { defineProps, ref } from "vue";

const props = defineProps({
    mobile_form: Object,  
    identifier: String
});

const labels = ref([
    {
        text: "psim",
        value: "physical",
    },
    {
        text: "esim",
        value: "esim",
    },
]);

const checkValue = (e) => {
    if (e === "clicked") {
        props.errors["user_sim_type"] = false;
    } else {
        if (props.mobile_form["user_sim_type"] !== null) {
            props.errors["user_sim_type"] = false;
        } else {
            props.errors["user_sim_type"] = true;
        }
    }
};

defineExpose({
    checkValue,
    identifier: props.identifier
});
</script>
<style lang="scss">
.card-header {
    background-color: #036bfb;
    color: white;
}
</style>
